import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { isCordova } from '../../../util/mobile/deviceDetection';

const SectionAppVersionComponent = () => {
  if (!isCordova() || !window.currentAppVersion) {
    return null;
  }

  return (
    <Typography align="center" color="text.secondary" variant="caption">
      <FormattedMessage id="MobileMenu.appVersion" values={{ version: window.currentAppVersion }} />
    </Typography>
  );
};

SectionAppVersionComponent.displayName = 'SectionAppVersion';
const SectionAppVersion = memo(SectionAppVersionComponent);

export default SectionAppVersion;
